/**
 * Created by apokdev on 6/6/17.
 */
import React, {Component} from "react";
import {Link} from 'react-router-dom';
import Vacio from "./Vacio";
import {hideHeader} from "../constants/functions";
import {getJSON} from '../constants/network';
import routes from '../constants/routes';
import BreadCrumb from "./Breadcrumbs";
import Regiones from "./Regiones";
import Ruta from "./Ruta";
import {getCurrentEstado} from '../constants/functions';

export default class extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rutas: [],
            sector: {
                pois: []
            },
            regiones: []
        };
    }

    loadRutaFromServer() {
        if (this.props.match.params.estado !== "_") {
            let rutas = undefined;
            let regiones = undefined;
            getJSON(routes.regionAll)
                .then(regionesResult => {
                    regiones = regionesResult.data;
                    return getJSON(routes.estadoBy + "/" + this.props.match.params.estado + "/rutas?items=999");
                }).then(rutasResult => {
                    rutas = rutasResult.data;
                    this.setState({rutas, regiones},() => console.log(this.state));
                });
            getJSON(`${routes.estadoBy}/${this.props.match.params.estado}`)
                .then(result => {
                    this.setState({
                        region: result.data.region.slug
                    })
                })
        } else {
            getJSON(routes.regionAll)
                .then(regionesResult => {
                    return getCurrentEstado(regionesResult.data);
                })
                .then(estadoResult => {
                    this.props.history.push(`/estado/${estadoResult}/rutas/_`);
                })
                .catch(estadoError => {
                    this.props.history.push(`/estado/${estadoError}/rutas/_`);
                });
        }
    }

    componentDidMount() {
        hideHeader();
        this.loadRutaFromServer();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match.params.estado !== this.props.match.params.estado) {
            this.loadRutaFromServer();
        }
    }

    render() {
        let breadcrumbs = [
            {url: `/#estado/${this.props.match.params.estado}`, text: this.props.match.params.estado},
            {url: null, text: "Rutas"}
        ];

        if (this.props.match.params.estado === "_" || !this.state.rutas) {
            return (<Vacio/>);
        }
        return (
            <div>
                <div id="cambio-sector" className={`${this.state.region}`}>
                    <div className="contenedor-sector">
                        <BreadCrumb links={breadcrumbs}/>
                    </div>
                </div>
                <div className="contenedor-sector">

                    <div className="col-sm-3">
                        <div id="sector-menu">
                            <div className="panel-group" id="accordion">
                                {
                                    this.state.regiones.map((region) => {
                                        return (
                                            <div className="panel panel-default panel-filtro-poi"
                                                 key={`region_${region.region}`}>
                                                <div className="panel-heading" role="tab">
                                                    <h4 className="panel-title">
                                                        <a href={"#collapse" + region.slug} role="button"
                                                           data-toggle="collapse" data-parent="accordion"
                                                           className="collapsed">{region.region}
                                                            <span className="fa fa-fw fa-caret-down pull-right"/>
                                                            <span className="fa fa-fw fa-caret-up pull-right"/>
                                                        </a>
                                                    </h4>
                                                </div>
                                                <div className="panel-collapse collapse"
                                                     id={`collapse${region.slug}`}>
                                                    <div className={`panel-body estados-list ${region.slug}`}>
                                                        <ul>
                                                            {
                                                                region.estados.map(estado => {
                                                                    return (
                                                                        <li className="estado" key={`${estado}`}>
                                                                            <Link to={`/estado/${estado}/rutas/_`}>
                                                                                <h3>{estado}</h3>
                                                                            </Link>
                                                                        </li>
                                                                    )
                                                                })
                                                            }
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-9" id="sector-data">
                        <ul className="pois-destacados">
                            {
                                this.state.rutas.map(function (ruta) {
                                    return (<li key={ruta.id}><Ruta ruta={ruta}/></li>)
                                })
                            }
                        </ul>
                    </div>
                </div>

                <div className="include-region">
                    <Regiones completo={false}/>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Rutas.js